/** Google Analytics 4 measurement ID — keep in sync with public/index.html. */
export const GA_MEASUREMENT_ID =
  process.env.REACT_APP_GA_MEASUREMENT_ID || 'G-XQSKF1P4L7';

const GA_ALLOWED_HOSTS = [
  'daiv.co',
  'www.daiv.co',
  'daivbharathi.com',
  'www.daivbharathi.com',
];

export function isGoogleAnalyticsAllowedHost(hostname) {
  const host = String(hostname || '').toLowerCase().replace(/^www\./, 'www.');
  return GA_ALLOWED_HOSTS.includes(host);
}

export function isGoogleAnalyticsAllowedOnCurrentHost() {
  if (typeof window === 'undefined') return false;
  if (window.__daivGoogleAnalyticsAllowed === false) return false;
  return isGoogleAnalyticsAllowedHost(window.location.hostname);
}
